import React from 'react';
import Banners1 from '../../Assets/Images/banner.png';
import '../../Assets/Css/Banner.css';

const Banner = () => {
  return (
    <div className="banner-container">
      <img src={Banners1} alt="Hero Banner" className="banner-image" />
    </div>
  );
};

export default Banner;
